

export const categoryData = [
  {
    title: 'داستانی',
    color: '#ff1257',
    id: 1,
  },
  {
    title: 'فلسفی',
    color: '#11cf24',
    id: 2,
  },
  {
    title: 'روانشناسی',
    color: '#4f5bd5',
    id: 3,
  },
  {
    title: 'نجوم',
    color: '#3908fc',
    theme: 'dark',
    id: 4,
  },
  {
    title: 'جامعه شناسی',
    color: '#cf7911',
    id: 5,
  },
  {
    title: 'ادبی',
    color: '#cf11cb',
    id: 6,
  },
  {
    title: 'تاریخی',
    color: '#d6e00d',
    id: 7,
  },
  {
    title: 'مذهبی',
    color: '#960e2b',
    id: 8,
  },
  {
    title: 'سلامت',
    color: '#0e5296',
    id: 9,
  }
];
